export class CounterBlock {
    constructor() {
        const counterBlocks = document.querySelectorAll('.counter-block');
        const speed = 1000;
        window.addEventListener('scroll', function () {
            counterBlocks.forEach((counter: HTMLElement) => {
                if ( isInViewport(counter) && ! counter.classList.contains('visible') ) {
                    const _counter = <HTMLElement>counter.querySelectorAll('.count-value')[0];
                    counter.classList.add('visible');
                    const updateCount = () => {
                        const target = parseInt(_counter.getAttribute('data-target'));
                        const count = parseInt(_counter.innerText);
                        const increment = Math.trunc(target / speed) < 1 ? 1 : Math.trunc(target / speed);
                        
                        if (count < target) {
                            _counter.innerText = `${count + increment}`;
                            setTimeout(updateCount, 1);
                        } else {
                            _counter.innerText = `${target}`;
                        }
                    };
                    updateCount();
                }
            });
        }, {
            capture: true
        });
    }
}

function isInViewport(element: HTMLElement) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}